import { render, staticRenderFns } from "./PricingInboundItemReport.vue?vue&type=template&id=83e32166&"
import script from "./PricingInboundItemReport.vue?vue&type=script&lang=js&"
export * from "./PricingInboundItemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports